export default __webpack_public_path__ + "static/media/tree11.4bcac14e.png";